import React from "react";
import './new-quiz.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import AssessmentApi from "../../../apis/assessment";
import TestApi from "../../../apis/test";
import SchoolNamesBulkImport from "../school-names-bulk-import/school-names-bulk-import";
import ToasterComponent from "../../common/cw-toaster-component/cw-toaster-component";

class NewQuiz extends React.Component {

    state = {
        quizName: '',
        numberOfRounds: '',
        studentsCount: '',
        newlyAddedMobileNumber: ["4000440007","4000440008"]
    }

    onClickBack() {
        this.props.delegate && this.props.delegate.hideNewQuiz && this.props.delegate.hideNewQuiz()
    }


    onClickCreateQuiz() {
        let payload = {
            quizName: this.state.quizName,
            numberOfRounds: this.state.numberOfRounds,
            studentsCount: this.state.studentsCount,
            newlyAddedMobileNumber : this.state.newlyAddedMobileNumber.length ? this.state.newlyAddedMobileNumber: [],
            type: 'CLICKER_QUIZ',
            selectedType : this.state.selectedType // Inter Schools Quiz or Within Students Quiz
        }

        TestApi.createClickerQuiz(payload).then(res => {
            this.props?.delegate?.showSuccessMessage && this.props.delegate.showSuccessMessage()
        }).catch(err => {
            console.log(err)
        })
    }

    setSelectedType(type) {
        this.setState({ selectedType: type })
    }

    showSchoolNamesUploadModal() {
        this.setState({ showSchoolNamesBulkUploadModal: true })
    }

    hideBulkSchoolNamesImport = () => {
        this.setState({ showSchoolNamesBulkUploadModal: false })
    }

    onSaveSchoolsName = (newlyAddedMobileNumber) => {
        this.hideBulkSchoolNamesImport()
        this.setState({ newlyAddedMobileNumber }, () => {
            this.showToaster('info', "Schools Name Uploaded successfully")
        })
        // this.getStudent(this.filter)
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 8000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    render() {
        return (
            <div className="new-quiz">
                <div>
                    <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>
                <div className="row pt-4" >
                    <div className="col screen-title">{this.props?.title || "New Quiz"}</div>
                </div>

                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Quiz Name<span className='text-danger'>*</span>
                        </div>
                        <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                            <input className={`cw-input-1`}
                                placeholder="Enter Quiz Name"
                                onChange={(event) => this.setState({ quizName: event.target.value })}
                                value={this.state.quizName}
                                onFocus={() => this.setState({ invalidName: false })}
                                maxLength={150} />
                        </div>
                        {/* {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''} */}
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Number of Quiz Rounds<span className='text-danger'>*</span>
                        </div>
                        <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                            <input className={`cw-input-1`}
                                placeholder="Enter Number of Quiz Rounds"
                                onChange={(event) => this.setState({ numberOfRounds: event.target.value })}
                                value={this.state.numberOfRounds}
                                onFocus={() => this.setState({ invalidName: false })}
                                maxLength={150} />
                        </div>
                        {/* {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''} */}
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            Participants <span className='text-danger'>*</span>
                        </div>
                        <div className="d-flex mt-2">
                            <div className="d-flex align-items-center cursor-pointer" onClick={() => this.setSelectedType('INTER_SCHOOLS_QUIZ')}>
                                <div className="circle mr-1">{this.state.selectedType === 'INTER_SCHOOLS_QUIZ' ? <div className="inner-circle"></div> : <></>}</div>
                                <div>Schools</div>
                            </div>
                            <div className="d-flex align-items-center cursor-pointer ml-4" onClick={() => this.setSelectedType('STUDENTS_QUIZ')}>
                                <div className="circle mr-1">{this.state.selectedType === 'STUDENTS_QUIZ' ? <div className="inner-circle"></div> : <></>}</div>
                                <div>Students</div>
                            </div>
                        </div>
                        {/* <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                            <input className={`cw-input-1`}
                                placeholder="Enter Number of Students"
                                onChange={(event) => this.setState({ studentsCount: event.target.value })}
                                value={this.state.studentsCount}
                                onFocus={() => this.setState({ invalidName: false })}
                                maxLength={150} />
                        </div> */}
                        {/* {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''} */}
                    </div>

                    {
                        this.state.selectedType === 'INTER_SCHOOLS_QUIZ' ?
                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                <div className="filter-input-label upload-button cursor-pointer" onClick={() => this.showSchoolNamesUploadModal()}>
                                    Click Here to Schools List Excel {this.state.newlyAddedMobileNumber.length ? <img className="green-tick-mark ml-2" src={getImageSource(ImageConstants.GREEN_TICK_ICON)} /> : <></>}
                                </div>
                            </div>
                            :
                            <></>
                    }
                </div>

                {this.state.showSchoolNamesBulkUploadModal && <SchoolNamesBulkImport mode={this.state.mode} size={'lg'} onSave={this.onSaveSchoolsName} onClose={this.hideBulkSchoolNamesImport} type="INTER_SCHOOLS_QUIZ" />}

                <div className="row float-right">
                    <div className="col-1 pt-4">
                        <div className={` ${this.state.isAdaptive ? 'create-homework-absolute-adaptive' : ''} 
                                    ${this.props.moreThanOneBoard ? 'create-homework-for-more-than-one-board' : ''}`}>
                            <div className={` cursor-pointer d-flex align-items-center justify-content-center text-center create-button d-inline-block cw-btn-primary ${this.props.moreThanOneBoard ? 'create-button-for-more-than-one-board' : ''}`} onClick={() => this.onClickCreateQuiz()}>
                                Create Quiz
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}

            </div>
        )
    }

}

export default NewQuiz;